import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { medicationsData } from '__mocks__/mockData/medications-data';

const Medications = [
  rest.get(`${API_ROOT}medications`, (req, res, ctx) => {
    const keyword = req.url.searchParams.get('keyword');
    if (keyword) {
      return res(ctx.json(medicationsData));
    }
    return res(ctx.json({}));
  }),
];
export default Medications;
